module.exports = __webpack_public_path__ + "media/images/common/ico-logout-bd7a2dd555ee96eb64c8f209cd848f49.svg";